import React, { useEffect, useState } from 'react'
import useGetData from 'Hooks/useGetData'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import { DataTable, ToolPanel,TabView,  } from 'Components/readonly'
import { PageConstraint, PageHeader } from 'Components/layout'
import { FormattedMessage, useIntl } from 'react-intl'
import { SearchInput, Datepicker } from 'Components/input'
import axios from 'axios'

export const LogPage = () => {

  const [isLoadingRecent, recentLogs] = useGetData('/rapi/admin/log/recent', [])

  const [actionLogs, setActionLogs] = useState([]);
  const [isLoadingActions, setIsLoadingActions] = useState(false);

  const [systemLogs, setSystemLogs] = useState([]);
  const [isLoadingSystem, setIsLoadingSystem] = useState(false);

  const [userLogs, setUserLogs] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);

  const intl = useIntl()
  const [globalFilter, setGlobalFilter] = useState('')
  const [first, setFirst] = useState(0)
  const [rows, setRows] = useState(localStorage.hasOwnProperty('numLogRows') ? parseInt(localStorage.getItem('numLogRows')) : 20)
  const [date, setDate] = useState();

  useEffect(() => {

    localStorage.setItem('numLogRows', rows);

    const fetchActionLogs = async () => {

        setIsLoadingActions(true);
        const url = date
          ? '/rapi/admin/log/actions?date=' + date.toLocaleDateString("sv-SE")
          : '/rapi/admin/log/actions';

        const result = await axios.get(url);
        setActionLogs(result.data.data ?? result.data);
        setIsLoadingActions(false);
      };

    const fetchSystemLogs = async () => {
        setIsLoadingSystem(true);
        const url = date
          ? '/rapi/admin/log/system?date=' + date.toLocaleDateString("sv-SE")
          : '/rapi/admin/log/system';

        const result = await axios.get(url);
        setSystemLogs(result.data.data ?? result.data);
        setIsLoadingSystem(false);
      };

    const fetchUserLogs = async () => {
        setIsLoadingUsers(true);
        const url = date
          ? '/rapi/admin/log/users?date=' + date.toLocaleDateString("sv-SE")
          : '/rapi/admin/log/users';

        const result = await axios.get(url);
        setUserLogs(result.data.data ?? result.data);
        setIsLoadingUsers(false);
      };

      fetchActionLogs();
      fetchSystemLogs();
      fetchUserLogs();

  }, [rows, date]);

  return (
    <PageConstraint>
      <PageHeader>
        <h1>
          <FormattedMessage id="log.admin-log"/>
        </h1>
        <ToolPanel>
          <SearchInput
            value={globalFilter}
           onChange={(event) => {
              setGlobalFilter(event.target.value)
              setFirst(0)
            }}
          />
          <Datepicker
            value={date}
            onChange={(e) => setDate(e.value)}
          />
        </ToolPanel>
      </PageHeader>
      <TabView>
        <TabPanel
          header={intl.formatMessage({ id: 'log.tabs.recent' })}
        >
          <DataTable
            className="flextable"
            value={recentLogs}
            paginator={true}
            loading={isLoadingRecent}
            rows={rows}
            rowsPerPageOptions={[5, 20, 100]}
            globalFilter={globalFilter}
            first={first}
            onPage={(e) => {
              setFirst(e.first)
              setRows(e.rows)
            }}>
            <Column
              field="created_at"
              header={intl.formatMessage({ id: 'common.when' })}
              sortable={false}
              style={{ width: '1%', whiteSpace: 'nowrap' }}
            />
            <Column field="whom" header={intl.formatMessage({ id: 'common.who' })} sortable={false}
                    style={{ width: '1%' }}/>
            <Column field="message" header={intl.formatMessage({ id: 'common.what' })} sortable={false}/>
          </DataTable>
        </TabPanel>

        <TabPanel
          header={intl.formatMessage({ id: 'log.tabs.actions' })}
        >
          <DataTable
            className="flextable"
            value={actionLogs}
            paginator={true}
            loading={isLoadingActions}
            rows={rows}
            rowsPerPageOptions={[5, 20, 100]}
            globalFilter={globalFilter}
            first={first}
            onPage={(e) => {
              setFirst(e.first)
              setRows(e.rows)
            }}>
            <Column
              field="created_at"
              header={intl.formatMessage({ id: 'common.when' })}
              sortable={false}
              style={{ width: '1%', whiteSpace: 'nowrap' }}
            />
            <Column field="whom" header={intl.formatMessage({ id: 'common.who' })} sortable={false}
                    style={{ width: '1%' }}/>
            <Column field="message" header={intl.formatMessage({ id: 'common.what' })} sortable={false}/>
          </DataTable>
        </TabPanel>
         <TabPanel
          header={intl.formatMessage({ id: 'log.tabs.system' })}
        >
          <DataTable
            className="flextable"
            value={systemLogs}
            paginator={true}
            loading={isLoadingSystem}
            rows={rows}
            rowsPerPageOptions={[5, 20, 100]}
            globalFilter={globalFilter}
            first={first}
            onPage={(e) => {
              setFirst(e.first)
              setRows(e.rows)
            }}>
            <Column
              field="created_at"
              header={intl.formatMessage({ id: 'common.when' })}
              sortable={false}
              style={{ width: '1%', whiteSpace: 'nowrap' }}
            />
            <Column field="whom" header={intl.formatMessage({ id: 'common.who' })} sortable={false}
                    style={{ width: '1%' }}/>
            <Column field="message" header={intl.formatMessage({ id: 'common.what' })} sortable={false}/>
          </DataTable>
        </TabPanel>
         <TabPanel
          header={intl.formatMessage({ id: 'log.tabs.users' })}
        >
          <DataTable
            className="flextable"
            value={userLogs}
            paginator={true}
            loading={isLoadingUsers}
            rows={rows}
            rowsPerPageOptions={[5, 20, 100]}
            globalFilter={globalFilter}
            first={first}
            onPage={(e) => {
              setFirst(e.first)
              setRows(e.rows)
            }}>
            <Column
              field="created_at"
              header={intl.formatMessage({ id: 'common.when' })}
              sortable={false}
              style={{ width: '1%', whiteSpace: 'nowrap' }}
            />
            <Column field="whom" header={intl.formatMessage({ id: 'common.who' })} sortable={false}
                    style={{ width: '1%' }}/>
            <Column field="message" header={intl.formatMessage({ id: 'common.what' })} sortable={false}/>
          </DataTable>
        </TabPanel>
      </TabView>
    </PageConstraint>
  )
}
